// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ZYCq","left":"InfoRow_left__3qeNP"};